export default __webpack_public_path__ + "static/media/Cartão de Natal - Opção 01.35bc43bb.png";